module.exports = __webpack_public_path__ + "static/img/9en.6fd598f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/9en.png
// module id = 3jfe
// module chunks = 0